import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\AnonymousController::store
* @see app/Http/Controllers/AnonymousController.php:15
* @route 'https://app.pokor.dev/anonymous/identity'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://app.pokor.dev/anonymous/identity',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnonymousController::store
* @see app/Http/Controllers/AnonymousController.php:15
* @route 'https://app.pokor.dev/anonymous/identity'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnonymousController::store
* @see app/Http/Controllers/AnonymousController.php:15
* @route 'https://app.pokor.dev/anonymous/identity'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AnonymousController::update
* @see app/Http/Controllers/AnonymousController.php:44
* @route 'https://app.pokor.dev/anonymous/name'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: 'https://app.pokor.dev/anonymous/name',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\AnonymousController::update
* @see app/Http/Controllers/AnonymousController.php:44
* @route 'https://app.pokor.dev/anonymous/name'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnonymousController::update
* @see app/Http/Controllers/AnonymousController.php:44
* @route 'https://app.pokor.dev/anonymous/name'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\AnonymousController::logout
* @see app/Http/Controllers/AnonymousController.php:71
* @route 'https://app.pokor.dev/anonymous/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: 'https://app.pokor.dev/anonymous/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnonymousController::logout
* @see app/Http/Controllers/AnonymousController.php:71
* @route 'https://app.pokor.dev/anonymous/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnonymousController::logout
* @see app/Http/Controllers/AnonymousController.php:71
* @route 'https://app.pokor.dev/anonymous/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AnonymousController::show
* @see app/Http/Controllers/AnonymousController.php:96
* @route 'https://app.pokor.dev/anonymous/identity'
*/
export const show = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/anonymous/identity',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AnonymousController::show
* @see app/Http/Controllers/AnonymousController.php:96
* @route 'https://app.pokor.dev/anonymous/identity'
*/
show.url = (options?: RouteQueryOptions) => {
    return show.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnonymousController::show
* @see app/Http/Controllers/AnonymousController.php:96
* @route 'https://app.pokor.dev/anonymous/identity'
*/
show.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AnonymousController::show
* @see app/Http/Controllers/AnonymousController.php:96
* @route 'https://app.pokor.dev/anonymous/identity'
*/
show.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(options),
    method: 'head',
})

const anonymous = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    logout: Object.assign(logout, logout),
    show: Object.assign(show, show),
}

export default anonymous